/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import { useTranslation } from "react-i18next";

import { useAppState, ScreenRegistry  } from "@ef/feature-app";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import WaitContainer from "../WaitContainer";

export default function LoadingScreen() {
    const { t } = useTranslation();
    const { initialized } = useAppState();

    const text = initialized ? t("Lade Ansicht...") : t("Initialisiere Anwendung...");
    return <StaticLoadingScreen text={text} />;
}

export type StaticLoadingScreenProps = {
    readonly text: string
}

export function StaticLoadingScreen({ text }: StaticLoadingScreenProps) {

    return (
        <WaitContainer>
            <Box mt={3}>
                <Typography>{text}</Typography>
            </Box>
        </WaitContainer>
    );
}

ScreenRegistry.set("loading", LoadingScreen);
